import React, { useState } from 'react';
import BookingCard from './BookingCard';
import { bookingsService } from '../../services/api';
import styles from './CheckoutList.module.css';

const CheckoutList = ({ data, onRefresh }) => {
  const [searchTerm, setSearchTerm] = useState('');

  if (!data) {
    return <div className={styles.loading}>Loading checkout data...</div>;
  }

  const filtered = data.checkouts.filter((b) =>
    searchTerm
      ? b.bookingNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
        b.guestName.toLowerCase().includes(searchTerm.toLowerCase())
      : true
  );

  const handleCheckout = async (bookingId) => {
    try {
      const response = await bookingsService.checkOut(bookingId);
      
      // Handle payment warnings from backend
      if (response.warning) {
        alert(`${response.warning}\n\nCheckout completed successfully.`);
      } else {
        alert('Guest checked out successfully');
      }
      onRefresh();
    } catch (error) {
      console.error('Checkout failed:', error);
      // Handle payment validation errors from backend
      const errorMessage = error.error || error.message || 'Failed to check out booking';
      alert(`${errorMessage}`);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.summary}>
        <div className={styles.stat}>
          <span className={styles.statLabel}>Total</span>
          <strong className={styles.statValue}>{data.totalCheckouts}</strong>
        </div>
        <div className={styles.stat}>
          <span className={styles.statLabel}>Pending</span>
          <strong className={`${styles.statValue} ${styles.pending}`}>
            {data.pendingCheckouts}
          </strong>
        </div>
        <div className={styles.stat}>
          <span className={styles.statLabel}>Completed</span>
          <strong className={`${styles.statValue} ${styles.completed}`}>
            {data.totalCheckouts - data.pendingCheckouts}
          </strong>
        </div>
      </div>

      <div className={styles.controls}>
        <input
          type="text"
          placeholder="Search by booking number or guest name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className={styles.search}
        />
      </div>

      <div className={styles.list}>
        {filtered.length === 0 ? (
          <div className={styles.empty}>
            {data.pendingCheckouts === 0 ? (
              <p>All check-outs completed!</p>
            ) : (
              <p>No bookings match your search</p>
            )}
          </div>
        ) : (
          filtered.map((booking) => (
            <BookingCard
              key={booking.id}
              booking={booking}
              action={
                booking.status !== 'CHECKEDOUT' ? (
                  <button
                    className={styles.actionButton}
                    onClick={() => handleCheckout(booking.id)}
                  >
                    Check Out
                  </button>
                ) : (
                  <span className={styles.done}>Checked Out</span>
                )
              }
            />
          ))
        )}
      </div>
    </div>
  );
};

export default CheckoutList;
